import { FuzzySearch, getCarListV2 } from '@/api/domain/cars'
import selectOption from '@/store/dict/selectOptionDict'
import CARDICT from '@/store/dict/carDict.js'
import { dict2list } from '@/utils/index'
import { h } from 'vue'
import { TABS, tabList } from './index'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'
// 全部车辆、待入库、待租、已租配置
export const CommonConfig = ({
  table,
  tab,
  autoQuery,
  carStateList,
  operations,
  getTags,
  cityList,
}) => {
  return {
    formData: {
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'plateNo',
          },
          elConfig: {
            remote: true,
            clearable: true,
            filterable: true,
            reserveKeyword: true,
            defaultFirstOption: true,
            remoteMethod: (query) => {
              const keyWords = query.trim()
              if (keyWords.length > 3) {
                FuzzySearch({
                  plateNo: query.trim(),
                  state: 1,
                }).then((res) => {
                  const { data } = res
                  table.value?.setItemData({
                    elConfigKey: 'list',
                    key: 'plateNo',
                    data: data || [],
                  })
                })
              }
            },
            placeholder: '请输入',
            options: {
              label: 'plateNo',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '车辆ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            clearable: true,
            placeholder: '请输入车辆ID',
          },
        },
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'select',
          itemConfig: {
            label: '运营城市',
            prop: 'adcode',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            reserveKeyword: true,
            defaultFirstOption: true,
            placeholder: '请选择',
            options: {
              label: 'city',
              value: 'adcode',
              list: cityList,
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '车辆创建时间',
            prop: 'carCreateTime',
          },
          elConfig: {
            format: 'yyyy-MM-dd',
            'value-format': 'yyyy-MM-dd HH:mm:ss',
            type: 'daterange',
            'range-separator': '至',
            'start-placeholder': '开始日期',
            'end-placeholder': '结束日期',
            clearable: true,
            'default-time': ['00:00:00', '23:59:59'],
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '车辆标签',
            prop: 'tagId',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '采购类型',
            prop: 'purchaseType',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'label',
              value: 'value',
              list: dict2list(selectOption.carPurchaseType),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '采购状态',
            prop: 'purchaseState',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'label',
              value: 'value',
              list: dict2list(selectOption.vehiclePurchaseStatus),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '车源方',
            prop: 'providerId',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: 'VIN码',
            prop: 'vin',
          },
          elConfig: {
            clearable: true,
            maxlength: 18,
            placeholder: '请输入',
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '发动机号',
            prop: 'engineNo',
          },
          elConfig: {
            maxlength: '20',
            placeholder: '请输入',
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '订单',
            prop: 'lockedState',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'label',
              value: 'value',
              list: [
                {
                  label: '未锁定',
                  value: 0,
                },
                {
                  label: '已锁定',
                  value: '1',
                },
              ],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '能源类型',
            prop: 'energyType',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '电池冷却方式',
            prop: 'coolingMode',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择',
            filterable: false,
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        },
      ],
      exportData: {
        // 导出模板，用于查找对应的导出方法
        // export.js文件中需存在以'export{{exportTemplate}}'命名的导出方法，例如：exportReturnCarOrderList
        exportTemplate: 'CarList',
        // 导出的文件名称
        filename: '车辆管理.xlsx',
        // 资源权限（可选）
        permissionName: 'vehicle_list_export',
      },
      clickSearch: () => {
        if (tab === TABS.All) {
          getTags && getTags()
        }
      },
      dealWithSearch: (params) => {
        // 品牌车型车系参数处理
        const { brandSeriesModel, carCreateTime } = params
        if (brandSeriesModel) {
          const { brandId, seriesId, modelId } = brandSeriesModel
          params.seriesId = seriesId
          params.modelId = modelId
          params.brandId = brandId
        }
        // 创建时间参数处理
        if (carCreateTime) {
          const [carCreateStartDate, carCreateEndDate] = carCreateTime
          params.carCreateStartDate = carCreateStartDate
          params.carCreateEndDate = carCreateEndDate
        }
        delete params.carCreateTime
        delete params.brandSeriesModel
        // 添加tab参数
        const tabParams = tabList[tab].params
        params = {
          ...params,
          ...tabParams,
        }
        params.carMatterTabNo = autoQuery?.g?.itemType
        return params
      },
      customizeReset: () => {
        table.value.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '车辆ID',
            width: 100,
          },
          render({ row }) {
            if (!operations.lookCarDetail.judgePermission(row)) return row.id
            return (
              <span
                class="a-hover-link"
                onClick={() => operations.lookCarDetail.handler(row)}
              >
                {row.id}
              </span>
            )
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'vin',
          columnProps: {
            prop: 'vin',
            label: 'VIN码',
            width: 180,
          },
        },
        {
          name: 'city',
          columnProps: {
            prop: 'city',
            label: '运营城市',
          },
        },
        {
          name: 'brand',
          columnProps: {
            prop: 'brand',
            label: '品牌',
          },
        },
        {
          name: 'series',
          columnProps: {
            prop: 'series',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'engineNo',
          columnProps: {
            prop: 'engineNo',
            label: '发动机号',
            width: 160,
          },
        },
        {
          name: 'carState',
          columnProps: {
            prop: 'carState',
            label: '车辆状态', // 新添加的车辆状态
          },
          getText: ({ row }) => carStateList.value[row.carState],
        },
        {
          name: 'purchaseType',
          columnProps: {
            prop: 'purchaseType',
            label: '采购类型',
          },
          getText: ({ row }) => selectOption.carPurchaseType[row.purchaseType],
        },
        {
          name: 'energyTypeDesc',
          columnProps: {
            prop: 'energyTypeDesc',
            label: '能源类型',
            width: 120,
          },
        },
        {
          name: 'coolingModeDesc',
          columnProps: {
            prop: 'coolingModeDesc',
            label: '电池冷却类型',
            width: 120,
          },
        },
        {
          name: 'tagList',
          columnProps: {
            prop: 'tagList',
            label: '车辆标签',
            width: 120,
          },
          render({ row }) {
            if (row && row.tagList) {
              return row.tagList.map((item) => {
                return h(
                  'el-tag',
                  {
                    props: {
                      size: 'mini',
                    },
                  },
                  item,
                )
              })
            } else {
              return '--'
            }
          },
        },
        {
          name: 'lockedState',
          columnProps: {
            prop: 'lockedState',
            label: '订单',
          },
          getText: ({ row }) => {
            if (row.lockedState === 0) return '未锁定'
            if (row.lockedState === 1) return '已锁定'
            return '--'
          },
        },
        {
          name: 'inventoryTime',
          columnProps: {
            prop: 'inventoryTime',
            label: '在库时长',
          },
          getText: ({ row }) => {
            const time = row.inventoryTime
            return time ? `${time}天` : '--'
          },
        },
        {
          name: 'userName',
          columnProps: {
            prop: 'userName',
            label: '所属车管',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '车辆创建时间',
            width: 160,
          },
        },
        {
          name: 'providerName',
          columnProps: {
            prop: 'providerName',
            label: '车源方',
            width: 160,
          },
        },
        {
          name: 'purchaseState',
          columnProps: {
            prop: 'purchaseState',
            label: '采购状态',
          },
          getText: ({ row }) =>
            selectOption.vehiclePurchaseStatus[row.purchaseState],
        },
        {
          name: 'basicItemState',
          columnProps: {
            prop: 'basicItemState',
            label: '车辆基本信息状态',
            width: 160,
          },
          render({ row }) {
            if ([1, 2, 3].includes(Number(row.basicItemState))) {
              return h(
                'span',
                {
                  on: {
                    click: () => {
                      operations.infoClick.handler(row)
                    },
                  },
                  class: 'yearInspectDate_red cursor-point',
                },
                CARDICT.CAR_MESSAGE()[row.basicItemState],
              )
            }
            return h(
              'span',
              {
                class: 'cursor-point',
                on: {
                  click: () => {
                    operations.infoClick.handler(row)
                  },
                },
              },
              CARDICT.CAR_MESSAGE()[row.basicItemState],
            )
          },
        },
        {
          name: 'operateState',
          columnProps: {
            prop: 'operateState',
            label: '运营状态',
          },
          badgeProps: ({ row }) => {
            return {
              text: selectOption.carOperateStateDict[row.operateState],
              color: row.operateState === 1 ? '#2E7EFF' : '#F5770A',
            }
          },
          type: 'badge',
        },
        {
          name: 'mortgagor',
          columnProps: {
            prop: 'mortgagor',
            label: '车辆抵押方',
            width: 150,
          },
        },
        {
          name: 'licenseOwner',
          columnProps: {
            prop: 'licenseOwner',
            label: '行驶证所有人',
            width: 150,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          type: 'operate',
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const ops = []
            const OPERATE_NAME = [
              'signCar',
              'editCar',
              'outCar',
              'careCar',
              'fixCar',
              'accidentCar',
              'prepareCar',
              'addInsure',
              'confirmCarInStore',
              'cancelPrepareCar',
              'dealCar',
            ]
            OPERATE_NAME.forEach((i) => {
              const op = operations[i]
              op.judgePermission(row) &&
                ops.push({
                  name: i,
                  label: op.label,
                  action: () => op.handler(row),
                })
            })
            return ops
          },
        },
      ],
      apiFn: getCarListV2,
    },
  }
}
